
import Cookies from "plugins/cookies-js"
import log from "plugins/loglevel/index"
import _flow from "lodash/flow"

const LOGGING_PREFIX = "App.ActionWithTimeout"
// The dot is just for easier reading
// Better not change it
const CACHE_KEY_PREFIX = "App.ActionWithTimeout"

const local_logger = log.getLogger(LOGGING_PREFIX)

const wrap_message = (message: any) => `${LOGGING_PREFIX} ${message}`
const wrap_message_func = (func: ((...args: any[]) => any)) => _flow(wrap_message, func)
const old_method = local_logger.methodFactory

local_logger.methodFactory = _flow(old_method, wrap_message_func)
// Required to regenerate all methods
local_logger.setLevel(local_logger.getLevel())


/*
 * Before running FuncToExec, check cacheKey and timeoutInMs
 * using https://github.com/ScottHamper/Cookies
 * If not set then exec and set cache key
 *
 * @param [string] cacheKey the cache key, will prepend with prefix
 * @param [Number] timeoutInSec timeout in second, taht's what lib Cookies use
 * @param [Func] The function to execute
 * @param [FuncOnNotExec] Called whenever it's decided not to execute Func
 */
const execute = (cacheKey: string, timeoutInSec: number, FuncToExec: (() => any), FuncOnNotExec?: (() => any)) => {
  const _key = `${CACHE_KEY_PREFIX}.${cacheKey}`
  local_logger.debug(`Trying to check cookies for cache key <${_key}>`)

  if (Cookies.enabled && Cookies.get(_key)){
    // Unless we need compatibility for old Chrome users
    // Just use `typeof` for checking an object is a `function` or not
    // https://stackoverflow.com/questions/17108122/isfunctiona-vs-typeof-a-function-javascript
    if (typeof FuncOnNotExec === "function"){
      return FuncOnNotExec()
    }
    else{
      return
    }
  }

  local_logger.debug(`Executing for cache key <${_key}>`)
  const result = FuncToExec()

  if (Cookies.enabled){
    local_logger.debug(`Saving cookies with cache key <${_key}>`)
    Cookies.set(_key, true, {
      expires: timeoutInSec,
    })
  }
  return result
}

export default {
  execute,
}
